// src/functoolsPy.js

const functoolsPy = `
def reduce(func, iterable, initializer=None):
    it = iter(iterable)
    if initializer is None:
        try:
            initializer = next(it)
        except StopIteration:
            raise TypeError("reduce() of empty sequence with no initial value")
    accum_value = initializer
    for x in it:
        accum_value = func(accum_value, x)
    return accum_value
`;
export default functoolsPy;
